import { gql } from '@apollo/client';

export const VerifyCode = gql`
    mutation verifyCode($email: String!, $code: String!) {
        verifyCode(email: $email, code: $code) {
            ... on VerifyCodeSuccessType {
                message
                token
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
